<template>
  <v-container class="p5-4 my-5">
    <v-spacer></v-spacer>
    <!-- {{ relatedResult }} -->
  <!--  -->
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      relatedResult: null,
    };
  },
  components: {},
  created() {
    this.getRelatedResults();
  },

  methods: {
    parse() {
      const link = this.$route.params.link;
      this.file = link;
      this.url = link.link_to_file;
      return link;
    },
    async getRelatedResults() {
      const { selectedId: id } = this;
      const relatedResult = await axios.get("/files/search/results/" + id);
      this.relatedResult = relatedResult.data;
      console.log(this.relatedResult);
    },
  },
  computed: {
    selectedId() {
      return Number(this.$route.params.id);
    },
  },
};
</script>


<style scoped>
</style>